import * as React from 'react'

export const FilledHeart = ({ size = 20, ...props }: { size?: number } & React.SVGProps<SVGSVGElement>) => (
  <svg width={size} height={size} fill="none" viewBox="0 0 14 14" {...props}>
    <defs>
      <linearGradient
        id="filledHeartGradient"
        x1="2.273"
        x2="10.428"
        y1="0.782"
        y2="8.937"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F86E6B" />
        <stop offset={1} stopColor="#FD1212" />
      </linearGradient>
    </defs>
    <path
      fill="url(#filledHeartGradient)"
      d="M11.446 7.858c-.772.928-1.877 1.866-3.157 2.961-.43.371-.928.792-1.446 1.241a.743.743 0 0 1-.978 0c-.518-.45-1.007-.87-1.446-1.24-1.28-1.096-2.385-2.034-3.157-2.962C.412 6.822 0 5.834 0 4.759a3.947 3.947 0 0 1 1.006-2.707A3.395 3.395 0 0 1 3.55.947a3.21 3.21 0 0 1 1.994.694c.312.245.576.528.801.85.225-.322.499-.605.801-.85A3.15 3.15 0 0 1 9.15.957a3.396 3.396 0 0 1 2.541 1.105 3.948 3.948 0 0 1 1.007 2.707c.01 1.065-.4 2.053-1.251 3.089Z"
    />
  </svg>
)

export default FilledHeart
